import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
declare var jquery: any;
declare var $: any;
declare var swal: any;

import { RestCallerService } from '../../common/services/rest-caller.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoginError = false;
  showLoader: boolean;
  showForgotPassword: boolean;

  showInternalPasswordTip: boolean;
  extPattern: RegExp;


  constructor(private router: Router, private restCallerService: RestCallerService) {
  }

  ngOnInit() {
    this.showLoader = false;
    this.loginForm = new FormGroup({
      'username': new FormControl(null, Validators.required),
      'password': new FormControl(null)
    });

    this.extPattern = new RegExp
    ("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");

    this.loginForm.valueChanges.subscribe(data => {
      this.userNameChecker(data.username, data.password);
    });
  }

  userNameChecker(username: string, password: string) {
    if (this.extPattern.test(username) === true) {
      this.showForgotPassword = true;
    }
    else {
      this.showForgotPassword = false;
    }
  }

  userNameFocusOut() {
    if (this.loginForm.controls['username'].value != "" && this.showForgotPassword == false) {
      this.showInternalPasswordTip = true;
    } else {
      this.showInternalPasswordTip = false;
    }
  }


  loginUser() {
    const username: string = this.loginForm.value['username'];
    const password: string = this.loginForm.value['password'];
    if (!password || password==='') {
      swal('Failure!', 'Password cannot be blank!', 'error');
      return;
    }
    this.showLoader = true;
    this.restCallerService.authenticateUser(username, password).subscribe(
      data => {
        this.showLoader = false;
        const response = data.json();
        sessionStorage.setItem('authToken', response.authToken);
        sessionStorage.setItem('authTokenExpiry', response.authTokenExpiry);
        sessionStorage.setItem('currentUser', JSON.stringify(data.json()));
        if (data.json()['pwdExpiry'] === null) {
          this.router.navigate(['/home/client-payroll-management']);
        } else {
          swal("Time to set up permanent password!", "Temporary password has been successfully validated. Now please set up your own password on the next screen.", "info");
          this.router.navigate(['resetpassword']);
        }
      },
      err => {
        this.showLoader = false;
        console.log(err);
        this.isLoginError = true;
        $('.card').addClass('animated shake');
        setTimeout(() => {
          $('.card').removeClass('animated shake');
        }, 2000);
      });
  }

  forgotPassword(event) {
    if (event)
      event.preventDefault();
    if (!this.loginForm.value['username']) {
      // this.loginForm.value['username'] = prompt("Please enter your email address");
      swal({
        title: "Password Reset",
        text: "Enter your username (which is your email address):",
        content: "input",
        buttons: true
      }).then((value) => {
        if (value) {
          this.loginForm.value['username'] = value;
          this.forgotPassword(null);
        }
      });
      return;
    }
    this.showLoader = true;
    this.restCallerService.forgotPassword(this.loginForm.value['username']).subscribe(
      data => {
        this.showLoader = false;
        this.loginForm.value['username'] = null;
        this.loginForm.patchValue({username: ''});
        swal("Success!", "Email sent with temporary password!", "success");
      },
      err => {
        this.showLoader = false;
        this.loginForm.value['username'] = null;
        this.loginForm.patchValue({username: ''});
        console.log(err.json());
        swal("Failure!", err.json().message, 'error');
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts